import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'
import { selectFormValue } from 'workspace/selectors'

const WorkspaceFormQuantity = ({ quantity, onChange, quantityType, style, formId }) => (
  <WorkspaceFormInput attribute={quantityType} extraErrorsAttribute='quantity' style={style} formId={formId}>
    <input
      type='number'
      min='0'
      className='workspace-form__input'
      value={(quantity || quantity === 0) ? quantity : ''}
      onChange={(e) => onChange({ [quantityType]: e.target.value ? Number(e.target.value) : null })}
    />
  </WorkspaceFormInput>
)

WorkspaceFormQuantity.defaultProps = {
  quantityType: 'quantity'
}

WorkspaceFormQuantity.propTypes = {
  quantityType: PropTypes.oneOf(['quantity', 'quantityLeft', 'quantityRight']),
  quantity: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  style: PropTypes.object,
  formId: PropTypes.string
}

const mapStateToProps = (state, { quantityType, formId }) => ({
  quantity: selectFormValue(state, quantityType || 'quantity', formId)
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChange: data => dispatch(changeFormData(data, ownProps.formId))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormQuantity)
